const str = `import './logger'
import './buffer'
import './setTimeout'
`

export default str
